<template>
  <Base :base-id="'lb-my-coupon'" :base-class="'coupon-popup'">
    <template #header>
      <h3 class="modal-title">折價券</h3>
    </template>
    <template #body>
      <div class="controls-item custom-ui filled-coupon">
        <label class="self-input" for="coupon-default">
          <input
            v-model.trim="selfKeyIn"
            type="text"
            class="form-control"
            name="self-coupon"
            placeholder="自行輸入折價券代碼"
            @click="enterCoupon"
          />
        </label>
      </div>
      <div
        v-for="(c, index) in modalData"
        :key="index"
        class="controls-item custom-ui selected-coupon"
      >
        <input
          :id="'coupon-' + index"
          v-model="couponSelected"
          name="coupon-selected"
          type="radio"
          :value="c.Code"
        />
        <label :for="'coupon-' + index">
          <span>{{ c.Code }}</span>
          <span>{{ c.Description }}</span>
          <p>使用期限: {{ c.EndDate }}</p>
        </label>
      </div>
      <div class="coupon-popup-info">
        <p>
          單筆訂單限抵一張折價券。<br />
          取消訂單、辦理整筆退貨或退貨後之保留商品未符合折價券<br />
          使用條件時，若折價券能仍在使用期限內，將歸還至帳戶中。
        </p>
      </div>
    </template>
    <template #footer>
      <a id="btn-coupon-discount" class="btn coupon-popup-btn" @click.prevent="checkCoupon">
        確定使用
      </a>
    </template>
  </Base>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import Base from '@global/components/common/modal/Base.vue';

import useAlert from '@global/composable/useAlert';
import useModalStore from '@global/stores/useModalStore';

const { alertDialog } = useAlert();

const modalStore = useModalStore();
const { modalData } = storeToRefs(modalStore);

const couponSelected = ref('');
const selfKeyIn = ref('');

watch(selfKeyIn, (nV) => {
  if (nV !== '') {
    couponSelected.value = '';
  }
});

watch(couponSelected, (nV) => {
  if (nV !== '') {
    selfKeyIn.value = '';
  }
});

function enterCoupon() {
  couponSelected.value = '';
}

function checkCoupon() {
  if (couponSelected.value === '' && selfKeyIn.value === '') {
    alertDialog.alert('請輸入或選擇折價代碼');
    return;
  }
  modalData.value = { coupon: selfKeyIn.value === '' ? couponSelected.value : selfKeyIn.value };
}
</script>
